import { usePage } from "@inertiajs/react";
import { Button, FormLabel, Stack, TextField } from "@mui/material";
import { useState } from "react";

import useFetch from "../../../hooks/useFetch";

const EmailForm = ({
  disabled,
  onSuccess,
}: {
  disabled?: boolean;
  onSuccess: (response: Record<string, string>) => void;
}) => {
  const { baseUrl } = usePage().props;
  const [email, setEmail] = useState("");
  const [post, { loading }] = useFetch<Record<string, string>>(
    `${baseUrl}/email_authentication`,
    {
      method: "POST",
      onSuccess: ({ json }) => onSuccess(json),
    },
  );

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        post({ nopassword_email_authentication: { email } });
      }}
    >
      <Stack spacing={1}>
        <FormLabel>Voer je e-mailadres is om door te gaan</FormLabel>
        <TextField
          autoFocus
          fullWidth
          helperText="Hierop ontvang je het telefoonnummer of e-mailadres om een betaalverzoek naar te versturen. Je email wordt met niemand gedeeld en we verwijderen hem na afloop."
          name="email"
          placeholder="email@voorbeeld.nl"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </Stack>
      <Stack direction="row" justifyContent="end">
        <Button
          loading={loading || disabled}
          sx={{ marginTop: "1em" }}
          type="submit"
          variant="contained"
        >
          Verstuur
        </Button>
      </Stack>
    </form>
  );
};

export default EmailForm;
